import { ReactNode, useMemo, useRef, useState } from "react"
import ConfirmCambioAlmacen from "./ConfirmCambioAlmacen"

const ROOM_SERVICE_CATEGORY_NAMES = ["Alimentos", "Bebidas"]

function diffAgainstA<T>(
    arrayA: readonly T[],
    arrayB: readonly T[],
    arrayC: readonly T[]
): {
    addedInA: boolean
} {
    // Elementos nuevos en C
    const added = arrayC.filter((item) => !arrayB.includes(item))

    return {
        addedInA: added.some((item) => arrayA.includes(item)),
    }
}

// Valida que si a un almacen se le quita la categoría de Alimentos y/o Bebidas muestre un aviso de que los artículos con esa categoría ya no se van a ver en el almacen actual
const useCambioAlmacen = ({
    options,
    onConfirmed,
}: {
    options: { label: string; value: string }[]
    onConfirmed: (value: string[]) => void
}) => {
    const [showModalConfirm, setshowModalConfirm] = useState(false)
    const currentValue = useRef<string[]>([])
    const prevValueRef = useRef<string[]>([])

    const handleRoomServiceCategoryChange = ({ prevValue, value }: { prevValue: string[]; value: string[] }) => {
        const roomServiceCategoryIds = options
            .filter((o) =>
                ROOM_SERVICE_CATEGORY_NAMES.map((v) => v.toLowerCase().trim()).includes(o.label.toLowerCase().trim())
            )
            .map((cat) => cat.value)

        const { addedInA } = diffAgainstA(roomServiceCategoryIds, value, prevValue)
        if (addedInA) {
            currentValue.current = value
            prevValueRef.current = prevValue
            return setshowModalConfirm(true)
        }
        onConfirmed(value)
    }

    const ConfirmChangeModal: ReactNode = useMemo(() => {
        return (
            <ConfirmCambioAlmacen
                isOpen={showModalConfirm}
                onConfirm={({ confirmed }) => {
                    setshowModalConfirm(false)
                    if (confirmed) {
                        onConfirmed(currentValue.current)
                        currentValue.current = []
                        prevValueRef.current = []
                        return
                    }
                    onConfirmed(prevValueRef.current)
                    currentValue.current = []
                    prevValueRef.current = []
                }}
            />
        )
    }, [showModalConfirm])

    return { handleRoomServiceCategoryChange, showModalConfirm, ConfirmChangeModal }
}

export default useCambioAlmacen
